import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Button } from '@/components/ui/button';

const API_URL = process.env.REACT_APP_BACKEND_URL;

// Phase 1 part 2 item 5: the signed-in admin's own activity (rules only, counts + flags, no customer identifiers).
export const MyActivityCard = ({ token }) => {
  const [data, setData] = useState(null);
  const [err, setErr] = useState(null);
  const [loading, setLoading] = useState(false);
  const load = async () => {
    setLoading(true); setErr(null);
    try {
      const r = await axios.get(`${API_URL}/api/admin/my-activity`, { headers: { Authorization: `Bearer ${token}` } });
      setData(r.data);
    } catch (e) { setErr(e.response?.data?.detail || 'Could not load my activity'); } finally { setLoading(false); }
  };
  useEffect(() => { load(); /* eslint-disable-next-line react-hooks/exhaustive-deps */ }, [token]);
  const live = data?.live;
  return (
    <div className="rounded-2xl border border-border/60 p-5 mb-6" data-testid="my-activity-card">
      <div className="flex items-start justify-between gap-3">
        <div>
          <h3 className="font-semibold">My activity (last 24 h)</h3>
          <p className="text-xs text-muted-foreground">Your own admin requests, summarised by rules only. The daily version is e-mailed at 06:30 AWST. AI reviewer: {data?.ai_reviewer_enabled ? 'on' : 'off'}.</p>
        </div>
        <Button size="sm" variant="outline" onClick={load} disabled={loading} data-testid="my-activity-refresh-btn">{loading ? 'Loading…' : 'Refresh'}</Button>
      </div>
      {err && <p className="text-sm text-red-700 mt-2" data-testid="my-activity-error">{err}</p>}
      {live && (
        <div className="mt-3 grid gap-1 text-sm">
          {live.lines.map((l, i) => (
            <p key={i} className={`font-mono text-xs ${l.startsWith('Flag:') ? 'text-amber-800' : ''}`} data-testid={`my-activity-line-${i}`}>{l}</p>
          ))}
        </div>
      )}
      {data?.stored?.length > 0 && (
        <p className="text-[11px] text-muted-foreground mt-3" data-testid="my-activity-stored">Stored daily summaries: {data.stored.length} · latest {data.stored[0].window_end?.slice(0, 16)}Z · {data.stored[0].emailed?.ok ? 'e-mailed' : (data.stored[0].emailed?.skipped || 'not e-mailed')}</p>
      )}
    </div>
  );
};
